import { Link, useRouter } from '@tanstack/react-router';
import { ArrowLeft, Home, MapPinOff } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

export function NotFoundPage() {
  const { t } = useTranslation('common');
  const router = useRouter();

  return (
    <main className="grid min-h-full place-items-center bg-background px-6 py-12">
      <div className="w-full max-w-md text-center">
        <div className="mx-auto mb-6 grid size-16 place-items-center rounded-2xl bg-muted text-muted-foreground">
          <MapPinOff className="size-8" aria-hidden="true" />
        </div>
        <p className="mb-2 text-sm font-medium text-primary">404</p>
        <h1 className="text-3xl font-semibold tracking-tight">
          {t('notFound.title')}
        </h1>
        <p className="mt-3 text-sm leading-6 text-muted-foreground">
          {t('notFound.description')}
        </p>
        <div className="mt-8 flex flex-col-reverse justify-center gap-3 sm:flex-row">
          <Button variant="outline" onClick={() => router.history.back()}>
            <ArrowLeft aria-hidden="true" />
            {t('actions.back')}
          </Button>
          <Button nativeButton={false} render={<Link to="/" />}>
            <Home aria-hidden="true" />
            {t('actions.backHome')}
          </Button>
        </div>
      </div>
    </main>
  );
}
